<div class="page">
  <h1>Probestunden</h1>
  <p class="hint">
    Besuche der letzten 8 Wochen ohne Kurs-Eintragung. „Eintragen“ trägt den Schüler
    ab dem ersten Probe-Besuch in den Kurs ein.
  </p>

  @if (loading) {
    <p>Wird geladen …</p>
  } @else {
    <table>
      <thead>
        <tr><th>Name</th><th>Kurs</th><th>Erster Besuch</th><th>Letzter Besuch</th><th>Besuche</th><th></th></tr>
      </thead>
      <tbody>
        @for (trial of trials; track trial.sid + '-' + trial.cid) {
          <tr>
            <td>{{ trial.firstname }} {{ trial.lastname }}</td>
            <td>{{ trial.course }}</td>
            <td>{{ trial.first | date: 'dd.MM.yyyy' }}</td>
            <td>{{ trial.last | date: 'dd.MM.yyyy' }}</td>
            <td>{{ trial.visits }}</td>
            <td><button type="button" class="button-add" (click)="enroll(trial)">Eintragen</button></td>
          </tr>
        } @empty {
          <tr><td colspan="6">Keine offenen Probestunden.</td></tr>
        }
      </tbody>
    </table>
  }
</div>
